import React from "react";
import { GripVertical } from "lucide-react";

// Drag handle: draggable="true" lives here (not the row) so text inputs inside the row stay selectable.
const DragHandle = ({ index, onDragStart, onDragEnd, t }) => (
  <span
    draggable="true"
    onDragStart={(event) => onDragStart(event, index)}
    onDragEnd={onDragEnd}
    title={t("Drag to reorder")}
    aria-label={t("Drag to reorder")}
    className="shrink-0 self-stretch flex items-center text-slate-300 hover:text-slate-500 cursor-grab active:cursor-grabbing touch-none"
  >
    <GripVertical className="w-4 h-4" />
  </span>
);

export default DragHandle;
